import { useState } from 'react';
import {
    Box,
    Button,
    chakra,
    Heading,
    Input,
    InputGroup,
    InputLeftElement
} from '@chakra-ui/react';
import { EditIcon, CheckIcon, SearchIcon } from '@chakra-ui/icons';
import { IEditProfile, useEditProfile } from '../firebase';
import { suggestedSkills } from './suggestedSkills';
import Skill from './Skill';

export default function Skills({
    tools,
    strengths,
    loading,
    profileId
}: {
    tools: string[];
    strengths: string[];
    loading: boolean;
    profileId: string;
}) {
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [newSkill, setNewSkill] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const { mutate: edit } = useEditProfile(profileId);
    const accessToken = sessionStorage.getItem('accessToken') ?? '';

    const addSkill = (e: any, skill: string) => {
        e.preventDefault();

        const skillToBeAdded = skill ?? newSkill;
        if (tools.includes(skillToBeAdded)) {
            setNewSkill('');
            return;
        }

        const editedData: IEditProfile = {
            accessToken,
            data: { tools: [skillToBeAdded, ...tools] }
        };

        // TODO:leira must refresh data
        edit(editedData, {
            onSuccess: () => {
                console.log('successfully added tool!!');
                setIsEditing(false);
                setNewSkill('');
            },
            onError: (error) => {
                console.log('adding tool failed: ', error);
            }
        });

        e.target.reset();
    };

    const allSkills = tools?.map((skill, idx) => (
        <Skill
            key={skill + idx}
            isEditing={isEditing}
            isLoading={loading}
            profileId={profileId}
            setIsEditing={setIsEditing}
            skill={skill}
            strengths={strengths}
            tools={tools}
        />
    ));

    const allStrengths = strengths?.map((strength, idx) => (
        <Skill
            key={strength + idx}
            isEditing={isEditing}
            isLoading={loading}
            profileId={profileId}
            setIsEditing={setIsEditing}
            skill={strength}
            strengths={strengths}
            tools={tools}
        />
    ));

    return (
        <Box w="full" textTransform={'capitalize'}>
            <Heading
                size="md"
                mb="2"
                pl="25px"
            >
                Skills 🧠
                {/* {isEditing ? (
                    <Button
                        size="sm"
                        type="button"
                        style={{ color: 'lightgray', fontSize: '1.25rem' }}
                        onClick={() => {
                            setIsEditing(false);
                            setShowSuggestions(false);
                            setNewSkill('');
                        }}
                    >
                        <CheckIcon />
                    </Button>
                ) : (
                    <Button
                        size="sm"
                        type="button"
                        style={{ color: 'lightgray', fontSize: '1.25rem' }}
                        onClick={() => setIsEditing(true)}
                    >
                        <EditIcon />
                    </Button>
                )} */}
            </Heading>
            <Box
                border="1px solid"
                borderColor="midnight.50"
                borderRadius={{ lg: 'xl' }}
                backgroundColor="white"
                p="6"
                mb="24px"
            >
                <Heading size="sm" mb="1">
                    Tools I've Used 🛠️
                </Heading>
                <form onSubmit={(e) => addSkill(e, '')} style={{ margin: 0 }}>
                    <InputGroup hidden={!isEditing} mt={2} mb={2}>
                        <InputLeftElement>
                            <SearchIcon />
                        </InputLeftElement>
                        <Input
                            placeholder="Add a tool"
                            value={newSkill}
                            onChange={(e) => {
                                if (e.target.value === '') {
                                    setNewSkill('');
                                    setShowSuggestions(false);
                                } else {
                                    setShowSuggestions(true);
                                    setNewSkill(e.target.value);
                                }
                            }}
                        />
                    </InputGroup>
                </form>
                {showSuggestions && (
                    <ul
                        style={{
                            position: 'relative',
                            zIndex: 2,
                            border: '1px solid var(--chakra-colors-midnight-50)',
                            borderTop: 'none',
                            background: 'white',
                            listStyle: 'none',
                            margin: 0,
                            padding: '10px',
                            maxHeight: '25vh',
                            overflow: 'auto'
                        }}
                    >
                        {suggestedSkills
                            .filter((skill) => skill.toLowerCase().includes(newSkill))
                            .map((skill) => (
                                <chakra.li
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                        setShowSuggestions(false);
                                        setNewSkill(skill);
                                        addSkill(e, skill);
                                    }}
                                    sx={{
                                        ':hover': {
                                            background: 'lightgray'
                                        }
                                    }}
                                >
                                    {skill}
                                </chakra.li>
                            ))}
                    </ul>
                )}
                {allSkills}

                <Heading size="sm" mt="6" mb="1">
                    Strengths 💪
                </Heading>
                {allStrengths}
            </Box>
        </Box>
    );
}
